import { useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const RealOrderOption = ({ order, timeZone }) => {
  const { i18n } = useTranslation()

  const orderDate = new Intl.DateTimeFormat(i18n.language, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    timeZone,
  }).format(new Date(order.external_created))

  return (
    <Styles.Container>
      <Text type="bodyMMedium">{order.name}</Text>
      <Styles.Details type="bodySRegular">{`${order.email} · ${orderDate}`}</Styles.Details>
    </Styles.Container>
  )
}

export default RealOrderOption
